import { validator } from "@/utils/validator";
import dayjs from "dayjs";

export const informationSchema = validator.object().shape({
  type: validator.string().isSelection().emptyToNull().label("タグ").required(),
  title: validator.string().emptyToNull().label("タイトル").required(),
  content: validator.string().emptyToNull().label("本文").required(),
  startDate: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .when(["enableStartDate", "enableEndDate"], ([enableStartDate, enableEndDate], schema) => {
      let scm = enableStartDate ? schema.required() : schema.nullable();
      if (enableStartDate && enableEndDate) {
        scm = scm.isSameOrBeforeDate("endDate", { startLabel: "公開開始日", endLabel: "公開終了日" });
      }
      return scm;
    })
    .label("公開開始日")
    .nullable(),
  endDate: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .when("enableEndDate", ([enableEndDate], schema) => {
      if (enableEndDate) {
        return schema.isSameOrAfterDate("startDate", { startLabel: "公開開始日", endLabel: "公開終了日" }).required();
      }
      return schema.nullable();
    })
    .test("endDate-after-today", "「公開終了日」は今日より後の日付を指定してください。", (value) => {
      if (!value) return true;
      return value.isSameOrAfter(dayjs(), "day");
    })
    .label("公開終了日")
    .nullable(),

  enableStartDate: validator.boolean().required(),
  enableEndDate: validator.boolean().required(),
  file: validator.array().of(validator.mixed().isExtendFile()).label("ファイル添付").notRequired(),
  filePath: validator.string().emptyToNull().label("ファイル添付").notRequired(),
  emailBroadCastHistories: validator.array().nullable(),
});
